export enum Language {
  NB = 'nb',
  NN = 'nn',
}

export default Language
